import { useNavigate } from "react-router";
import { Screen } from "../components/Screen";
import { useLocale } from "../i18n/LocaleProvider";

/** The one answer for every address the app does not know, including ones it keeps to itself. */
export function NotFoundScreen() {
  const { t } = useLocale();
  const navigate = useNavigate();
  return <Screen title={t.today.title} back={() => navigate("/")}>{t.common.notFound}</Screen>;
}
